require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.values");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.circulatingWater = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    name: "CirculatingWater",
    data: function data() {
      return {
        name: '塘管家循环水示范基地',
        ossHost: this.$config.base.ossHost,
        kzqData: {
          switchNumber: 1,
          powerWidth: [],
          customerSwitchName: []
        },
        bucketList: [],
        biochemicalSystem: {},
        feedingSystemView: {},
        videoList: [],
        loading: false
      };
    },
    created: function created() {
      var vm = this;
      vm.loadInfo(); // window.onresize = function() {
      //     !vm.loading && vm.loadInfo()
      //     document.getElementById('root').style.fontSize = document.documentElement.offsetWidth / 3.75 + 'px';
      // }

      setInterval(vm.loadInfo, 300000);
    },
    methods: {
      loadKzqInfo: function loadKzqInfo(id) {
        var vm = this;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/iot/gov/kzq/data"),
          params: {
            iotDeviceId: id
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            vm.$message({
              type: 'warning',
              message: res.message || '服务器繁忙，请稍后~'
            });
            return;
          }

          var electricConsumption = res.data.electricConsumption;
          var maxPower = electricConsumption.sort(function (a, b) {
            return b - a;
          })[0] || 1;
          res.data.upPower = res.data.powerChangeRate ? parseInt(res.data.powerChangeRate * 1000) / 10 : 0;
          res.data.powerWidth = [res.data.electricConsumption[0] * 100 / maxPower / 320, res.data.electricConsumption[1] * 100 / maxPower / 320, res.data.electricConsumption[2] * 100 / maxPower / 320, res.data.electricConsumption[3] * 100 / maxPower / 320];
          res.data.maxIndex = electricConsumption.indexOf(maxPower);
          res.data.type = 0;
          res.data.switchNumber = 1; // res.data.data = [{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646064169,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646064799,"atermsVoltage":230,"btermsVoltage":230,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646065429,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.3,"switch4Current":0.0,"temperature":32,"createAt":1646066059,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646066104,"atermsVoltage":230,"btermsVoltage":230,"ctermsVoltage":240},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.3,"switch4Current":0.0,"temperature":32,"createAt":1646066239,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646066869,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.3,"switch4Current":0.0,"temperature":32,"createAt":1646067499,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646067724,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646068354,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646068984,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646069614,"atermsVoltage":230,"btermsVoltage":230,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646070244,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":0.0,"temperature":32,"createAt":1646070874,"atermsVoltage":226,"btermsVoltage":226,"ctermsVoltage":234},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646071504,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646072134,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646072764,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646073394,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646074024,"atermsVoltage":230,"btermsVoltage":230,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.6,"switch4Current":0.0,"temperature":32,"createAt":1646074249,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646074294,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.6,"switch4Current":0.0,"temperature":32,"createAt":1646074699,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646074924,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646075553,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646076183,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.6,"switch4Current":0.0,"temperature":32,"createAt":1646076453,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646076498,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646077128,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646077758,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646078388,"atermsVoltage":232,"btermsVoltage":230,"ctermsVoltage":240},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646079018,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646079648,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646080278,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646080908,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646081538,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646082168,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.6,"switch4Current":0.0,"temperature":32,"createAt":1646082393,"atermsVoltage":228,"btermsVoltage":226,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646082438,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.5,"switch4Current":0.0,"temperature":32,"createAt":1646083068,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":238},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646083698,"atermsVoltage":226,"btermsVoltage":226,"ctermsVoltage":234},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":32,"createAt":1646084328,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":31,"createAt":1646084958,"atermsVoltage":226,"btermsVoltage":226,"ctermsVoltage":234},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":31,"createAt":1646085588,"atermsVoltage":226,"btermsVoltage":226,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":31,"createAt":1646086218,"atermsVoltage":226,"btermsVoltage":226,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":0.0,"temperature":31,"createAt":1646086848,"atermsVoltage":226,"btermsVoltage":226,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.4,"switch4Current":5.2,"temperature":31,"createAt":1646086934,"atermsVoltage":224,"btermsVoltage":224,"ctermsVoltage":234},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":3.7,"temperature":31,"createAt":1646086938,"atermsVoltage":226,"btermsVoltage":226,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.5,"temperature":32,"createAt":1646087343,"atermsVoltage":224,"btermsVoltage":224,"ctermsVoltage":234},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":3.4,"switch4Current":3.5,"temperature":33,"createAt":1646087973,"atermsVoltage":226,"btermsVoltage":226,"ctermsVoltage":234},{"switch1Current":3.9,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.5,"temperature":33,"createAt":1646087978,"atermsVoltage":222,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":3.3,"switch2Current":3.0,"switch3Current":3.4,"switch4Current":3.5,"temperature":33,"createAt":1646088018,"atermsVoltage":222,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":3.4,"switch2Current":3.0,"switch3Current":3.2,"switch4Current":3.3,"temperature":34,"createAt":1646088648,"atermsVoltage":222,"btermsVoltage":220,"ctermsVoltage":230},{"switch1Current":3.3,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.5,"temperature":35,"createAt":1646088738,"atermsVoltage":222,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":3.3,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.5,"temperature":36,"createAt":1646089368,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":3.2,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.4,"temperature":37,"createAt":1646089998,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":234},{"switch1Current":3.1,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.4,"temperature":37,"createAt":1646090628,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":234},{"switch1Current":3.2,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.5,"temperature":38,"createAt":1646091258,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":234},{"switch1Current":3.0,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.4,"temperature":38,"createAt":1646091708,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":3.2,"switch2Current":3.0,"switch3Current":3.2,"switch4Current":3.4,"temperature":38,"createAt":1646091798,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":3.1,"switch2Current":3.0,"switch3Current":3.2,"switch4Current":3.4,"temperature":39,"createAt":1646092428,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":3.2,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.3,"temperature":40,"createAt":1646093058,"atermsVoltage":226,"btermsVoltage":222,"ctermsVoltage":234},{"switch1Current":3.2,"switch2Current":3.0,"switch3Current":3.2,"switch4Current":3.5,"temperature":40,"createAt":1646093148,"atermsVoltage":222,"btermsVoltage":220,"ctermsVoltage":232},{"switch1Current":3.2,"switch2Current":3.0,"switch3Current":3.2,"switch4Current":3.3,"temperature":40,"createAt":1646093193,"atermsVoltage":222,"btermsVoltage":220,"ctermsVoltage":232},{"switch1Current":3.2,"switch2Current":3.0,"switch3Current":3.2,"switch4Current":3.5,"temperature":40,"createAt":1646093373,"atermsVoltage":222,"btermsVoltage":220,"ctermsVoltage":232},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.3,"switch4Current":3.4,"temperature":40,"createAt":1646093467,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.2,"switch4Current":3.4,"temperature":40,"createAt":1646094093,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.2,"switch4Current":3.4,"temperature":40,"createAt":1646094723,"atermsVoltage":224,"btermsVoltage":222,"ctermsVoltage":232},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":3.1,"switch4Current":3.5,"temperature":41,"createAt":1646095353,"atermsVoltage":222,"btermsVoltage":220,"ctermsVoltage":230},{"switch1Current":0.0,"switch2Current":2.9,"switch3Current":3.3,"switch4Current":3.4,"temperature":41,"createAt":1646095533,"atermsVoltage":222,"btermsVoltage":222,"ctermsVoltage":230},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":0.0,"switch4Current":0.0,"temperature":41,"createAt":1646095766,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":39,"createAt":1646096388,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":0.0,"switch4Current":0.0,"temperature":38,"createAt":1646097018,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":0.0,"switch4Current":0.0,"temperature":36,"createAt":1646097648,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":0.0,"switch4Current":0.0,"temperature":35,"createAt":1646098278,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":35,"createAt":1646098908,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":35,"createAt":1646099538,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":34,"createAt":1646100168,"atermsVoltage":228,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":34,"createAt":1646100798,"atermsVoltage":230,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":34,"createAt":1646101428,"atermsVoltage":230,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":34,"createAt":1646102058,"atermsVoltage":230,"btermsVoltage":228,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":34,"createAt":1646102687,"atermsVoltage":230,"btermsVoltage":230,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":34,"createAt":1646103317,"atermsVoltage":230,"btermsVoltage":230,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.0,"switch3Current":0.0,"switch4Current":0.0,"temperature":34,"createAt":1646103947,"atermsVoltage":230,"btermsVoltage":230,"ctermsVoltage":236},{"switch1Current":0.0,"switch2Current":3.1,"switch3Current":0.0,"switch4Current":0.0,"temperature":35,"createAt":1646104577,"atermsVoltage":230,"btermsVoltage":230,"ctermsVoltage":238}]

          vm.kzqData = res.data;
          vm.drawKzqChart(0);
          !vm.loaded && setTimeout(function () {
            vm.drawKzqChart(0);
          }, 1000);
          vm.loaded = true;
        }).catch(function (err) {
          console.log(err);
        });
      },
      loadInfo: function loadInfo() {
        var vm = this;
        vm.loading = true;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/iot/baseScreen/recirculationWater"),
          params: {
            encodeId: vm.$route.params.id
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            vm.$message({
              type: 'warning',
              message: res.message || '服务器繁忙，请稍后~'
            });
            return;
          }

          res.data.areaInfo.kzqInfo && vm.loadKzqInfo(res.data.areaInfo.kzqInfo.encodeId);
          vm.name = res.data.name;
          vm.initTlChart(res.data.areaInfo.feedingSystemView);
          vm.initPHChart(res.data.areaInfo.biochemicalSystem);
          vm.initNHChart(res.data.areaInfo.biochemicalSystem);
          res.data.areaInfo.bucketList && res.data.areaInfo.bucketList.map(function (bItem) {
            if ([23, 18, 34, 40].includes(res.data.id)) {
              bItem.name = bItem.name.replace('桶', '塘');
            }
          });
          vm.bucketList = res.data.areaInfo.bucketList;
          vm.biochemicalSystem = res.data.areaInfo.biochemicalSystem;
          vm.feedingSystemView = res.data.areaInfo.feedingSystemView;
          vm.videoList = res.data.areaInfo.videoList;
          setTimeout(vm.videoCtrl, 2000);
        }).catch(function (err) {
          console.log(err);
        });
      },
      videoCtrl: function videoCtrl() {
        var vm = this;
        vm.loading = false;
        var player = new window.Aliplayer({
          id: 'video-0',
          width: '100%',
          autoplay: true,
          source: vm.videoList[0].url,
          isLive: true,
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true
        }, function () {
          console.log('The player is created.');
        });
        player.setRotate(0);
        document.getElementsByTagName('video')[0].style.height = 'auto';

        if (vm.videoList[1]) {
          var player1 = new window.Aliplayer({
            id: 'video-1',
            width: '100%',
            autoplay: true,
            source: vm.videoList[1].url,
            isLive: true,
            preload: true,
            controlBarVisibility: "hover",
            useH5Prism: true
          }, function () {
            console.log('The player1 is created.');
          });
          player1.setRotate(0);
          document.getElementsByTagName('video')[1].style.height = 'auto';
        }
      },
      initTlChart: function initTlChart(feedingSystemView) {
        var vm = this;
        document.getElementById("tl-chart") && document.getElementById("tl-chart").setAttribute('_echarts_instance_', '');
        var myChart = vm.$echarts.init(document.getElementById('tl-chart'));
        var xData = Object.keys(feedingSystemView.weekFood);
        var yData = Object.values(feedingSystemView.weekFood);
        myChart.setOption({
          // width: '370px',
          animationDuration: 3000,
          grid: {
            bottom: 25,
            right: 10
          },
          tooltip: {
            trigger: 'axis',
            position: function position(pt) {
              return [pt[0], '10%'];
            }
          },
          title: {
            left: 'left',
            text: '今日投料量',
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: xData,
            axisTick: {
              show: false
            },
            axisLabel: {
              // show: false,
              textStyle: {
                color: '#fff'
              }
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: false
            },
            max: 100,
            minInterval: 50,
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
          },
          series: [{
            name: '投料量',
            type: 'bar',
            itemStyle: {
              color: '#9E8AFE'
            },
            barWidth: 35,
            data: yData
          }]
        });
      },
      // 渲染PH曲线
      initPHChart: function initPHChart(data) {
        var vm = this;
        document.getElementById("ph-chart") && document.getElementById("ph-chart").setAttribute('_echarts_instance_', '');
        var myChart = vm.$echarts.init(document.getElementById('ph-chart'));
        var xData = Object.keys(data.weekPh);
        var yData = Object.values(data.weekPh);
        xData.map(function (item, index) {
          xData[index] = "".concat(item.split('-')[1], "/").concat(item.split('-')[2]);
        });
        myChart.setOption({
          // height: 100,
          animationDuration: 3000,
          grid: {
            bottom: 40,
            right: 10,
            left: 30
          },
          tooltip: {
            trigger: 'axis',
            position: function position(pt) {
              return [pt[0], '10%'];
            }
          },
          title: {
            left: 'left',
            text: 'pH曲线',
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xData,
            axisTick: {
              show: false
            },
            axisLabel: {
              // show: false,
              textStyle: {
                color: '#fff'
              },
              rotate: 60
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: false
            },
            max: 14,
            minInterval: 7,
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
          },
          series: [{
            name: 'pH',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(99, 236, 255, 0)'
            },
            areaStyle: {
              color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#D389FE'
              }, {
                offset: 1,
                color: '#898BFE'
              }])
            },
            data: yData
          }]
        });
      },
      initNHChart: function initNHChart(data) {
        var vm = this;
        document.getElementById("nh-chart") && document.getElementById("nh-chart").setAttribute('_echarts_instance_', '');
        var myChart = vm.$echarts.init(document.getElementById('nh-chart'));
        var xData = Object.keys(data.weekNhn);
        var yData = Object.values(data.weekNhn);
        xData.map(function (item, index) {
          xData[index] = "".concat(item.split('-')[1], "/").concat(item.split('-')[2]);
        });
        myChart.setOption({
          // height: 100,
          animationDuration: 3000,
          grid: {
            bottom: 40,
            right: 10,
            left: 35
          },
          tooltip: {
            trigger: 'axis',
            position: function position(pt) {
              return [pt[0], '10%'];
            }
          },
          title: {
            left: 'left',
            text: '氨氮曲线',
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xData,
            axisTick: {
              show: false
            },
            axisLabel: {
              // show: false,
              textStyle: {
                color: '#fff'
              },
              rotate: 60
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: false
            },
            max: 0.5,
            minInterval: 0.25,
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
          },
          series: [{
            name: '氨氮',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(99, 236, 255, 0)'
            },
            areaStyle: {
              color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#D389FE'
              }, {
                offset: 1,
                color: '#898BFE'
              }])
            },
            data: yData
          }]
        });
      },
      handleCommand: function handleCommand(num) {
        this.kzqData.switchNumber = num;
        this.drawKzqChart(num - 1);
      },
      drawKzqChart: function drawKzqChart() {
        var vm = this;
        var date = [];
        var data = vm.kzqData.data ? vm.kzqData.data : [];
        var power = [];

        if (!data.length) {
          return;
        }

        if (new Date(data[0].createAt * 1000).getTime() - vm.$time.getUnixTime() > 60 * 3 * 1000) {
          data.unshift({
            switch1Current: '-',
            switch2Current: '-',
            switch3Current: '-',
            switch4Current: '-',
            createAt: vm.$time.getUnixTime() / 1000
          });
        }

        if (new Date(data[data.length - 1].createAt * 1000).getTime() - vm.$time.getUnixTime() < 3600 * 23.9 * 1000) {
          data.push({
            switch1Current: '-',
            switch2Current: '-',
            switch3Current: '-',
            switch4Current: '-',
            createAt: vm.$time.getUnixTime() / 1000 + 24 * 3600 - 1
          });
        }

        data.map(function (item, index_) {
          var count = data[index_ + 1] && (data[index_ + 1].createAt - item.createAt) / 700;

          if (count > 1) {
            power.push(item["switch".concat(vm.kzqData.switchNumber, "Current")]);
            date.push(vm.$time.getHoursMin(item.createAt * 1000));

            for (var j = 1; j < count; j++) {
              power.push('-');
              date.push(vm.$time.getHoursMin(item.createAt * 1000 + 700 * j * 1000));
            }
          } else {
            power.push(item["switch".concat(vm.kzqData.switchNumber, "Current")]);
            date.push(vm.$time.getHoursMin(item.createAt * 1000));
          }
        });

        try {
          document.getElementById("kzq-chart") && document.getElementById("kzq-chart").setAttribute('_echarts_instance_', '');
          var myChart = vm.$echarts.init(document.getElementById("kzq-chart"));
          myChart.setOption({
            // width: '370px',
            animationDuration: 3000,
            grid: {
              bottom: 20,
              top: 30,
              right: 20,
              left: 20
            },
            tooltip: {
              trigger: 'axis',
              position: function position(pt) {
                return [pt[0], '10%'];
              }
            },
            title: {
              left: 'center',
              text: ''
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: date,
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#fff'
                }
              }
            },
            yAxis: {
              type: 'value',
              boundaryGap: [0, '100%'],
              minInterval: 4,
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            series: [{
              name: '电流',
              type: 'line',
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: '#8CFFE9',
                borderWidth: 0.5
              },
              areaStyle: {
                color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(99, 236, 255, 50)'
                }, {
                  offset: 1,
                  color: 'rgba(99, 236, 255, 0)'
                }])
              },
              data: power
            }]
          });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };
  _exports.default = _default;
});